import React from 'react'
import { DataViewerUtil, HistoryTableView } from '@leverege/molten/data-viewers'
import { Content, Pane, Text } from '@leverege/ui-elements'
import { Toolbar } from '@leverege/ui-plugin'

import S from './ShelfCards.css'
import ShelfCards from './ShelfCards'

export default function ShelfMonitoring( props ) {
  const {
    settings,
    inCard,
    objectType,
    relationship,
    eventsPaginator
  } = props

  const { path } = relationship

  const actionBarMatchContext = {
    use : 'actionBar',
    client : ShelfMonitoring.CLIENT,
    objectType,
    path,
  }

  const context = {
    client : ShelfMonitoring.CLIENT,
    clientProps : props,
  }

  const content = (
    <Toolbar
      className={S.toolbar}
      variant="actionBar"
      prefer="icon"
      matchContext={actionBarMatchContext}
      context={context}/>
  )

  return (
    <Content variant="shelfMonitoring" className={S.content}>
      <Content.Header variant="shelfMonitoringHeader" layout="flex:rowMEnd">
        <DataViewerUtil.HeaderToolbar
          inCard={inCard}
          content={content} />
      </Content.Header>
      <Content.Area variant="shelfMonitoringArea" className={S.area}>
        <ShelfCards
          {...props}
          settings={settings.segments} />
        <Pane
          layout="flex:col"
          variant="cardNoPad">
          <div style={{
            height : '60px',
            padding : 'var(--size-padLarge)',
            borderBottom : '1px solid var(--color-base100)'
          }}>
            <Text variant="subtitle">Alerts</Text>
          </div>
          <div style={{
            height : 'calc(100% - 60px)',
            padding : '0 var(--size-padLarge) var(--size-padLarge) var(--size-padLarge)',
            position : 'relative'
          }}>
            <HistoryTableView
              {...props}
              settings={settings.table}
              objectType="product.event"
              paginator={eventsPaginator} />
          </div>
        </Pane>
      </Content.Area>
    </Content>
  )
}

ShelfMonitoring.CLIENT = 'ShelfMonitoringDataViewer'
